import { getItem } from "../../system/helpers/localstorageHelper";

export const isUserAllowed = (permissions: any) => {
  return (
    JSON.parse(getItem("roles"))?.filter((item) => permissions?.includes(item))
      .length > 0
  );
};
